import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { recordAudienceView } from "@/lib/audience";

/** Medición de audiencia sin cookies: una vista por cambio de ruta (y el
 *  tiempo de la anterior). Se usa una sola vez, en App, dentro del router.
 *  Detalles y reglas en src/lib/audience.ts. */
export function useAudience() {
  const { pathname } = useLocation();
  useEffect(() => {
    recordAudienceView(pathname);
  }, [pathname]);
}
